// extracted by mini-css-extract-plugin
export default {"menuBlock":"vF-z","title":"wF-z","nav":"xF-z","flexCell":"yF-z","facetLink":"zF-z"};